import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutsComponent } from './layouts.component';
import { PaymentPromotionCmsContentComponent } from './payment-promotion-cms-content/payment-promotion-cms-content.component';
import { GenericContentNodeComponent } from './generic-content-node/generic-content-node.component';
import { ViewTermsConditionPopupComponent } from './view-terms-condition-popup/view-terms-condition-popup.component';
import { SwiperModule } from 'swiper/angular';
import { CfmFooterComponent } from './cfm-footer/cfm-footer.component';


@NgModule({
  declarations: [
    LayoutsComponent,
    PaymentPromotionCmsContentComponent,
    GenericContentNodeComponent,
    ViewTermsConditionPopupComponent,
    CfmFooterComponent,
  ],
  exports: [
    PaymentPromotionCmsContentComponent,
    GenericContentNodeComponent,
    ViewTermsConditionPopupComponent,
    GenericContentNodeComponent,
    CfmFooterComponent
  ],
  imports: [
    CommonModule,
    SwiperModule
  ]
})
export class LayoutsModule { }
